module.exports = __webpack_public_path__ + "assets/fonts/inbound.d00c8b86.svg";